var VanityLookup = {
  // Demos
  "Shuffled-Demo-Single-Deck": "1N5eeyKTVWo5QeGcUV_zYtwtR0DikJCcvcj6w69UkC1w",
  "Shuffled-Demo-Multi-Deck": "1N2N8URSswhmxLalPOkzi5d4kdeFiGrsobEmM_ojk0ow",
  "Timed-Demo": "1yq2AKwaYL1uZrCnEfwgSpC0SPkQAZqnCdjNxH_pm018",
  "Monster-Demo": "1NgNHy7Qe1R8KhGR2cOmJwL2aOl2tocBemW2HIAKjrvI",
  "Slot-Machine-Demo": "1t5LRUQG9DzMJ3kd8E9DZV7_EbE8J5-Gqhz7TWQ4Y-uU",
  "Phases-Demo": "1HataDfV2lrA4hfzmLgDjXH09dEMLQV6OT10tVH9G52A",
  "Secret-Cards-Demo": "1JwMF02DSxNKtjHp6u-wyznSs-iEG_3DpOobgc17I16o",
  
  // Games
  "Compersion": "1XVd4Kgq3X3utOm25JXOsDbhI_jLjAHX8mGzpiT6Sgho",
  "Cute-Games-For-First-Dates": "1jaGlSVeBBCfRvY5j_lLrz5YC_psGOVURn_OaXbr2JH0",
  // "For-The-Awesome": "1ghm-XOUZlYaOeHcl0zer4KSpCMaoN5u_X7iWmN2TrjY",
  "Reunion": "1rJ3L8E_sBEqiRO8ADQeSAS2UmcK9Xzk0g_F0d_XkkRc",
  "This-Heart-Within-Me-Burns": "1WLy_IM9DehQbrBNjTdL67Bc-ZiW83INcfxlnzpDMqnA",

}

export default VanityLookup